import { NSARouterMakerResult } from 'namirasoft-account-react'
import { UserFullRow } from 'namirasoft-password'
import { Component } from 'react'
import { EntryTabPageView } from '../EntryTabPageView'
import { PasswordEntities } from '../PasswordEntities'
import { PasswordLayout } from '../PasswordLayout'
import { PasswordRouterProps } from '../PasswordRouterProps'

export interface EntryListPageProps extends NSARouterMakerResult, PasswordRouterProps
{
    user: UserFullRow;
}

class EntryListPage extends Component<EntryListPageProps>
{
    override render()
    {
        return (
            <PasswordLayout
                {...this.props}
                action={{
                    description: "See every saved login in your vault; open an entry to view, edit, or delete its details."
                }}
                pages={{
                    entity: PasswordEntities.entry(this.props),
                    list: {
                        ui: {
                            tab_page_view: EntryTabPageView.getTabPage(this.props)
                        }
                    }
                }}
            >
                <></>
            </PasswordLayout >
        )
    }
}

export default EntryListPage